<template>
  <div>
    <v-card class="mx-auto mt-4" max-width="95%" elevation="2">
      <v-toolbar color="#37474F" dark>
        <v-toolbar-title>전면 이벤트 관리</v-toolbar-title>
        <v-spacer></v-spacer>
        <v-btn color="cyan" small fab @click="OnClick_CreateEvent">
          <v-icon color="white">mdi-plus</v-icon>
        </v-btn>
      </v-toolbar>

      <v-list>
        <div style="overflow-x: auto;">
          <v-data-table
            :footer-props="{'items-per-page-options': [20, 50, -1]}"
            :headers="headers"
            :items="event_list"
            :loading="loadingData"
          >
            <template v-slot:item.THUMB_URL="{ item }">
              <img
                v-if="item.THUMB_URL"
                :src="item.THUMB_URL"
                alt="썸네일"
                style="width:60px; height:60px; object-fit:cover; border-radius:6px; margin:4px 0;"
              />
              <v-icon v-else color="grey lighten-2">mdi-image-off</v-icon>
            </template>
            <template v-slot:item.ENABLE_YN="{ item }">
              <v-icon small :color="item.ENABLE_YN === 'Y' ? 'green' : 'red'">
                {{ item.ENABLE_YN === 'Y' ? 'mdi-check-circle' : 'mdi-close-circle' }}
              </v-icon>
              <span class="ml-1 text-body-2">{{ item.ENABLE_YN === 'Y' ? '활성화' : '비활성화' }}</span>
            </template>
            <template v-slot:item.CREATE_DT="{ item }">
              <span class="text-body-2">{{ item.CREATE_DT }}</span>
            </template>
            <template v-slot:item.edit="{ item }">
              <v-btn color="primary" small outlined @click="OnClick_EditEvent(item)">
                <v-icon small left>mdi-pencil</v-icon>편집
              </v-btn>
            </template>
            <template v-slot:item.delete="{ item }">
              <v-btn color="red" small outlined @click="OnClick_DeleteEvent(item)">
                <v-icon small left>mdi-delete</v-icon>삭제
              </v-btn>
            </template>
          </v-data-table>
        </div>
      </v-list>
    </v-card>

    <!-- 생성/수정 다이얼로그 -->
    <v-dialog v-model="dialog_event" persistent max-width="700" :fullscreen="$vuetify.breakpoint.xsOnly">
      <v-card>
        <v-card-title class="text-h5 primary white--text">
          <v-icon left color="white">{{ dialog_mode_edit ? 'mdi-pencil' : 'mdi-plus' }}</v-icon>
          {{ dialog_mode_edit ? '이벤트 수정' : '이벤트 등록' }}
        </v-card-title>
        <v-card-text class="pa-4">
          <v-row>
            <v-col cols="12" md="6">
              <v-text-field
                v-model="dialog_thumb_url"
                label="썸네일 URL"
                outlined
                dense
                class="mb-2"
                placeholder="https://..."
                prepend-inner-icon="mdi-image"
              ></v-text-field>
              <v-img
                v-if="dialog_thumb_url"
                :src="dialog_thumb_url"
                height="120"
                contain
                class="mb-2 rounded"
                style="border: 1px solid #e0e0e0;"
              ></v-img>
            </v-col>
            <v-col cols="12" md="6">
              <v-text-field v-model="dialog_title" label="타이틀 *" outlined dense class="mb-2" maxlength="32" counter></v-text-field>
              <v-text-field v-model="dialog_desc_text" label="설명 *" outlined dense class="mb-2" maxlength="128" counter></v-text-field>
              <v-text-field v-model="dialog_button_text" label="버튼 문구 *" outlined dense maxlength="24" counter></v-text-field>
            </v-col>
          </v-row>
          <v-row>
            <v-col cols="12" md="4">
              <v-select
                v-model="dialog_link_type"
                :items="link_type_options"
                item-text="label"
                item-value="value"
                label="링크 타입"
                outlined
                dense
              ></v-select>
            </v-col>
            <v-col cols="12" md="8">
              <v-text-field
                v-model="dialog_link_path"
                label="링크 경로"
                outlined
                dense
                placeholder="예: https://example.com"
              ></v-text-field>
            </v-col>
          </v-row>
          <v-row>
            <v-col cols="12" md="4">
              <v-text-field
                v-model.number="dialog_priority"
                label="우선순위 (숫자가 낮을수록 우선)"
                type="number"
                outlined
                dense
              ></v-text-field>
            </v-col>
            <v-col cols="12" md="4" class="d-flex align-center">
              <v-switch
                v-model="dialog_enable_switch"
                inset
                :label="dialog_enable_switch ? '활성화' : '비활성화'"
                color="primary"
                hide-details
              ></v-switch>
            </v-col>
          </v-row>
        </v-card-text>
        <v-card-actions class="pa-4">
          <v-spacer></v-spacer>
          <v-btn color="grey" text @click="CloseEventDialog">취소</v-btn>
          <v-btn color="primary" @click="OnSave_Event" :loading="loadingData">저장</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
    <div class="py-12"/>
  </div>
</template>

<script>
import { mandoora_event } from '../../api/mandoora';

export default {
  name: 'MandooraGameEventNoti',
  data: () => ({
    loadingData: false,
    event_list: [],
    dialog_event: false,
    dialog_mode_edit: false,
    selected_pid: null,
    dialog_thumb_url: '',
    dialog_title: '',
    dialog_desc_text: '',
    dialog_button_text: '',
    dialog_link_type: 'LINK',
    dialog_link_path: '',
    dialog_priority: 1,
    dialog_enable_switch: true,
    link_type_options: [
      { label: '링크', value: 'LINK' },
      { label: '플레이스먼트', value: 'PLACEMENT' },
      { label: '캠페인', value: 'CAMPAIGN' },
      { label: '오퍼월', value: 'OFFERWALL' },
    ],
    headers: [
      { text: 'PID', value: 'PID', width: '70px' },
      { text: '썸네일', value: 'THUMB_URL', width: '90px', sortable: false },
      { text: '타이틀', value: 'TITLE' },
      { text: '링크 타입', value: 'LINK_TYPE', width: '110px' },
      { text: '우선순위', value: 'PRIORITY', width: '90px', align: 'center' },
      { text: '활성화', value: 'ENABLE_YN', width: '110px' },
      { text: '생성일', value: 'CREATE_DT', width: '160px' },
      { text: '편집', value: 'edit', width: '90px', align: 'center', sortable: false },
      { text: '삭제', value: 'delete', width: '90px', align: 'center', sortable: false },
    ],
  }),
  created() {
    this.LoadEventList();
  },
  methods: {
    async LoadEventList() {
      this.loadingData = true;
      try {
        const body = await mandoora_event.get_event_list();
        this.event_list = body?.event_list || body?.list || [];
      } catch (e) {
        console.error('[Mandoora EventNoti] get_event_list', e);
      } finally {
        this.loadingData = false;
      }
    },
    OnClick_CreateEvent() {
      this.dialog_mode_edit = false;
      this.selected_pid = null;
      this.dialog_thumb_url = '';
      this.dialog_title = '';
      this.dialog_desc_text = '';
      this.dialog_button_text = '';
      this.dialog_link_type = 'LINK';
      this.dialog_link_path = '';
      this.dialog_priority = 1;
      this.dialog_enable_switch = true;
      this.dialog_event = true;
    },
    OnClick_EditEvent(item) {
      this.dialog_mode_edit = true;
      this.selected_pid = item.PID;
      this.dialog_thumb_url = item.THUMB_URL || '';
      this.dialog_title = item.TITLE || '';
      this.dialog_desc_text = item.DESC_TEXT || '';
      this.dialog_button_text = item.BUTTON_TEXT || '';
      this.dialog_link_type = item.LINK_TYPE || 'LINK';
      this.dialog_link_path = item.LINK_PATH || '';
      this.dialog_priority = item.PRIORITY || 1;
      this.dialog_enable_switch = item.ENABLE_YN === 'Y';
      this.dialog_event = true;
    },
    async OnClick_DeleteEvent(item) {
      if (!confirm(`이벤트 [${item.TITLE}] 를 삭제하시겠습니까?`)) return;
      try {
        await mandoora_event.delete_event({ pid: item.PID });
        alert('삭제 완료');
        await this.LoadEventList();
      } catch (e) {
        console.error('[Mandoora EventNoti] delete_event', e);
        alert('삭제 실패');
      }
    },
    async OnSave_Event() {
      if (!this.dialog_title || !this.dialog_desc_text || !this.dialog_button_text) {
        alert('필수 항목을 모두 입력해주세요.');
        return;
      }
      const enable_yn = this.dialog_enable_switch ? 'Y' : 'N';
      this.loadingData = true;
      try {
        if (this.dialog_mode_edit) {
          await mandoora_event.edit_event({
            pid: this.selected_pid,
            thumb_url: this.dialog_thumb_url,
            link_type: this.dialog_link_type,
            link_path: this.dialog_link_path,
            title: this.dialog_title,
            desc_text: this.dialog_desc_text,
            button_text: this.dialog_button_text,
            priority: this.dialog_priority,
            enable_yn,
          });
          alert('이벤트가 수정되었습니다.');
        } else {
          await mandoora_event.create_event({
            thumb_url: this.dialog_thumb_url,
            link_type: this.dialog_link_type,
            link_path: this.dialog_link_path,
            title: this.dialog_title,
            desc_text: this.dialog_desc_text,
            button_text: this.dialog_button_text,
            priority: this.dialog_priority,
            enable_yn,
          });
          alert('이벤트가 등록되었습니다.');
        }
        this.CloseEventDialog();
        await this.LoadEventList();
      } catch (e) {
        console.error('[Mandoora EventNoti] save', e);
        alert('저장 실패');
      } finally {
        this.loadingData = false;
      }
    },
    CloseEventDialog() {
      this.dialog_event = false;
      this.dialog_mode_edit = false;
      this.selected_pid = null;
    },
    formatCoin(v) {
      const n = Number(v);
      return Number.isNaN(n) ? '0' : n.toLocaleString();
    },
  },
};
</script>

<style scoped>
@media (max-width: 600px) {
  .v-data-table { overflow-x: auto; }
}
</style>
